import ApiClient from './ApiClient';
import AttendSetting36AgreementDomain, { AttendSetting36Agreement } from 'domain/master/attend/attendSetting36Agreement';

export const getSetting36Agreement = async (targetYear: number): Promise<Array<AttendSetting36Agreement>> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

    const params = {
        targetYear
    }

    const response = await ApiClient.get(`/v1/attend36Agreements/${companyCode}`, params);
    return response.data;
};

export const getSetting36AgreementPrevious = async (targetYear: number): Promise<Array<AttendSetting36Agreement>> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

    const params = {
        targetYear,
        loginStaffCode: sessionStorage.getItem('loginUser.staffCode') || ''
    }

    const response = await ApiClient.post(`/v1/attend36Agreements/copy/${companyCode}`, params);
    return response.data;
};

export const postSetting36Agreement = async (values: any): Promise<Array<any>> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

    const response = await ApiClient.post(`/v1/attend36Agreements/${companyCode}`, values);
    return response.data;
};

export default getSetting36Agreement;
